export default {
  //粉体解决方案保存
  SAVE: '/jcnapi/solutionFt/save',
  GET: '/jcnapi/solutionFt/getInfo',
  GET_LIST: '/jcnapi/solutionFt/getList',
  DEL: '/jcnapi/solutionFt/delete',
  //解决方案类别 保存
  category: {
    SAVE: '/jcnapi/solutionFtCategory/save',
    GET_LIST: '/jcnapi/solutionFtCategory/getList',
    GET: '/jcnapi/solutionFtCategory/getInfo',
    DEL: '/jcnapi/solutionFtCategory/delete',
    GET_LIST_INDUSTRY: '/jcnapi/solutionFtCategoryIndustry/getList',
    INDUSTRY_SAVE: '/jcnapi/solutionFtCategoryIndustry/save',
    INDUSTRY_DEL: '/jcnapi/solutionFtCategoryIndustry/delete'
  },
  industry: {
    GET_LIST: '/jcnapi/solutionFtIndustry/getList',
    SAVE: '/jcnapi/solutionFtIndustry/save',
    DEL: '/jcnapi/solutionFtIndustry/delete'
  }
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/solution-ft/index.js